import { useEffect, useRef } from 'react';
import { SocketConnection } from '../socket/socket-main-thread/socket-connection';
import socketManager from '../socket/socket-main-thread/socket-manager';
import { SocketOperationError } from '@/types/registration.types';
import toastTrigger from '@ui/toast/toast-trigger';
import { EToastTypes } from '@ui/toast/toast.types';

export default function useAudienceError(channel: number | null | undefined) {
  const socket = useRef<SocketConnection | null>(null);

  useEffect(() => {
    if (!channel) return;

    const namespace = `admin-${channel}`;
    socket.current = socketManager.getFromHook(namespace);

    const handleError = (response: SocketOperationError) => {
      toastTrigger('Audience list error', {
        description: response.data.message,
        type: EToastTypes.error,
        autoClose: 10000,
      });
    };

    socket.current.addListener<SocketOperationError>('audience-error', handleError);

    return () => {
      socket.current?.removeListener('audience-error', handleError);
      socketManager.leave(namespace);
    };
  }, [channel]);
}
